module.exports = __webpack_public_path__ + "img/Icon material-archive.7e2466ab.svg";